import type { IComponentController } from "angular";

import { cloneDeep } from "lodash";

import type { IResponse } from "App/Modules/Models";
import type { IConfig } from "App/Modules/Utils";

export class ErrorComponentController implements IComponentController {
    public static $inject = ["irConfig"];

    public readonly NOT_AUTHORIZED_CODE = 403;

    public readonly TIMEOUT_CODE = 504;

    public error: IResponse<void>;

    public hideError = false;

    public showDetails = false;

    public mail = "";

    constructor(private irConfig: IConfig) {}

    public createMail() {
        const subject = this.subject();
        const body = this.body();
        const recipient = "support@irisity.com";

        this.mail = `${recipient}?Subject=${subject}&Body=${body}`;
    }

    public getPublicErrorInfo(error: IResponse<void>): IResponse<void> {
        const cloned = cloneDeep(error) as any;

        if (cloned.config.headers) {
            delete cloned.config.headers.Authorization;
        }

        if (cloned.config.data && cloned.config.data.password) {
            delete cloned.config.data.password;
        }

        if (cloned.config.data && cloned.config.data.twoFactorAuthCode) {
            delete cloned.config.data.twoFactorAuthCode;
        }

        cloned.headers = cloned.headers();

        return cloned;
    }

    public getErrorMessage() {
        switch (this.error.status) {
            case this.NOT_AUTHORIZED_CODE:
                return "Error.NotAuthorized";
            case this.TIMEOUT_CODE:
                return "Error.Timeout";
            default:
                return "Error.ErrorLoading.SendOrShow";
        }
    }

    protected subject(): string {
        let portal = "";
        if (this.irConfig.environment !== "prod") {
            portal = `(${this.irConfig.environment})`;
        }
        return `[Issue report] Issue report for ${document.title} ${portal}`;
    }

    protected body(): string {
        const activityId = this.error.headers("activity-id");
        const l = `${window.location?.href}`;

        return `Describe what you were trying to do: %0A%0A%0A%0A
Page url: ${encodeURIComponent(l)} %0A
Activity Id: ${activityId} %0A
Method and URL: ${this.error.config.method} ${this.error.config.url} %0A
Date: ${new Date().toLocaleString()} %0A
Exception message: ${this.error.error ? (this.error.error as any).message : ""} %0A`;
    }
}
